
import {
  IconCycle,
  IconGlasses,
  IconLeaf,
  IconThumbsUpOutlined,
  RevButton,
} from '@backmarket/design-system'
import isEmpty from 'lodash/isEmpty'

import { MODAL_NAMES } from '@config/constants'
import IllustrationEarth from '@core/illustrations/IllustrationEarth.svg'
import { productRenewedImpactModalFetch } from '@http/endpoints'

import ContentRow from '../../ContentRow'
import AsyncModal from '../AsyncModal'

const ICONS = {
  IconLeaf,
  IconCircle: IconCycle,
  IconThumbsUp: IconThumbsUpOutlined,
  IconGlasses,
}

const ILLUSTRATIONS = {
  IllustrationEarth,
}

export default {
  components: {
    AsyncModal,
    ContentRow,
    RevButton,
  },
  data() {
    return {
      content: {},
    }
  },
  computed: {
    modalName: () => MODAL_NAMES.PRODUCT.RENEWED_IMPACT,

    modalTitle() {
      return this.content.title
    },
    links() {
      return this.content.links
    },
    shouldDisplayLinks() {
      return !isEmpty(this.links)
    },
    renewedImpact() {
      return this.content.paragraphs?.map(({ icon, title, text }) => ({
        icon: ICONS[icon],
        labels: [text],
        title,
      }))
    },
    illustration() {
      return ILLUSTRATIONS[this.content.image]
    },

    productId() {
      return this.$route.params.uuid
    },
  },
  methods: {
    async fetchRenewedImpact() {
      const { payload } = await this.$store.dispatch('http/request', {
        request: productRenewedImpactModalFetch,
        pathParams: { productId: this.productId },
      })

      this.content = { ...payload }
    },
  },
}
